import { render, staticRenderFns } from "./UserPasswordForm.vue?vue&type=template&id=3c8d2f09&scoped=true"
import script from "./UserPasswordForm.vue?vue&type=script&lang=js"
export * from "./UserPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./UserPasswordForm.vue?vue&type=style&index=0&id=3c8d2f09&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d2f09",
  null
  
)

export default component.exports